import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription
} from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';

// Export delete confirmation. Shows booking/container # so the user knows
// what they're about to permanently remove.
export const DeleteConfirmDialog = ({ open, onOpenChange, exportData, deleting, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-md">
      <DialogHeader>
        <DialogTitle className="text-red-400">Delete Export</DialogTitle>
        <DialogDescription className="text-slate-400">
          Are you sure you want to delete this export? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <p className="text-white">
          Export: <span className="font-mono">{exportData?.booking_number || exportData?.container_number}</span>
        </p>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700">Cancel</Button>
        <Button onClick={onConfirm} disabled={deleting} className="bg-red-600 hover:bg-red-500">
          {deleting && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
